import { MSXAuthService } from './service-auth-msx';
import { AuthServiceBase } from './service-auth-base';

export class AuthService {
  /** The singleton instance of this class. */
  private static instance: AuthService;

  /** The singleton instance of the auth service to use */
  private static authServiceInstance: AuthServiceBase;

  public haveFallbacked: boolean = false;

  // Constructor
  constructor() {
    AuthService.authServiceInstance = new MSXAuthService();
  }

  // STATIC METHODS
  /**
   * Static method to get class instance.
   */
  public static get Instance() {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  // PUBLIC METHODS
  public get MEM_AUTH_SCOPE(): string {
    return AuthService.authServiceInstance.MEM_AUTH_SCOPE;
  }

  public get GRAPH_AUTH_SCOPE(): string {
    return AuthService.authServiceInstance.GRAPH_AUTH_SCOPE;
  }

  public async fallbackToMemAuthService(): Promise<void> {
    if (this.haveFallbacked) return Promise.reject(new Error('Already Fallbacked to MEMAuthService'));
    this.haveFallbacked = true;
    return new Promise<void>((resolve, reject) => {
      import('./service-auth-mem')
        .then((module) => {
          AuthService.authServiceInstance = new module.MEMAuthService();
          resolve();
        })
        .catch((error: Error) => {
          reject(error);
        });
    });
  }

  public async getLoggedAccountInfo(): Promise<any> {
    return new Promise((resolve, reject) => {
      AuthService.authServiceInstance
        .getAccountInfo()
        .then((accountInfo: any) => {
          resolve(accountInfo);
        })
        .catch((error: Error) => {
          reject(error);
        });
    });
  }

  public async getHeaderForScope(scope: string): Promise<string> {
    return new Promise((resolve, reject) => {
      AuthService.authServiceInstance
        .getTokenForScope(scope)
        .then((token: string) => {
          resolve(`Bearer ${token}`);
        })
        .catch((error: Error) => {
          // If error occurs and we haven't fallbacked yet, try fallback to MEM auth service
          if (!this.haveFallbacked) {
            this.fallbackToMemAuthService()
              .then(() => {
                // After successful fallback, retry getting the token
                return AuthService.authServiceInstance.getTokenForScope(scope);
              })
              .then((token: string) => {
                resolve(`Bearer ${token}`);
              })
              .catch((fallbackError: Error) => {
                reject(fallbackError);
              });
          } else {
            // If we already fallbacked or fallback not available, reject with original error
            reject(error);
          }
        });
    });
  }
}

export default AuthService.Instance;
